import React, { useEffect, useState, useCallback } from "react";
import { LuClipboard } from "react-icons/lu";
import { IoIosArrowDown } from "react-icons/io";
import { Dropdown, DropdownButton, Form } from "react-bootstrap";
import axios from "axios";
import { useLocation } from "react-router-dom";

function Submission({ onSubmissionDataChange }) {
  const location = useLocation();
  const { assessmentId } = location.state || {};
  const [showForm, setShowForm] = useState(false);
  const [selectedValue, setSelectedValue] = useState("Select attempts");
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [checkbox3, setCheckbox3] = useState(false);
  const [checkbox4, setCheckbox4] = useState(false);
  const [radioValue, setRadioValue] = useState("D");
  const [numberInput, setNumberInput] = useState("0");
  const [textInput, setTextInput] = useState("Minutes");

  const buttonStyle = {
    width: "100%",
    backgroundColor: "white",
    color: "#A63D00",
    borderColor: "#A63D00",
    fontFamily: "Manrope-Regular",
  };

  const updateSubmissionData = useCallback((data) => {
    onSubmissionDataChange((prevData) => ({ ...prevData, ...data }));
  }, [onSubmissionDataChange]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API}/getSetting?assessment_id=${assessmentId}`);
        if (response.data.success) {
          const data = response.data.data;
  
          setSelectedValue(data.no_of_attempts || "Select attempts");
          setCheckbox1(data.allow_group_submission?.data[0] === 1 || false); 
          setCheckbox2(data.time_limit?.data[0] === 1 || false); 
          setCheckbox3(data.view_score_immediate?.data[0] === 1 || false); 
          setCheckbox4(data.view_question_immediate?.data[0] === 1 || false); 
          setRadioValue(data.view_correct_answers || "D");
          setNumberInput(data.time || "0");
          setTextInput(data.time_extension || "Minutes");
  
          updateSubmissionData({
            selectedValue: data.no_of_attempts || "Select attempts",
            checkbox1: data.allow_group_submission?.data[0] === 1 || false,
            checkbox2: data.time_limit?.data[0] === 1 || false,
            checkbox3: data.view_score_immediate?.data[0] === 1 || false,
            checkbox4: data.view_question_immediate?.data[0] === 1 || false,
            radioValue: data.view_correct_answers || "D",
            numberInput: data.time || "0",
            textInput: data.time_extension || "Minutes",
          });
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };
  
    fetchSettings();
  }, [assessmentId, updateSubmissionData]);
  

  const handleToggleForm = () => {
    setShowForm(!showForm);
  };

  const handleSelect = (eventKey) => {
    if (selectedValue !== eventKey) {
      setSelectedValue(eventKey);
      updateSubmissionData({ selectedValue: eventKey });
    }
  };

  const handleCheckboxChange = (checkboxName, value) => {
    const updatedValue = !value;
    switch (checkboxName) {
      case "checkbox1":
        if (checkbox1 !== updatedValue) {
          setCheckbox1(updatedValue);
          updateSubmissionData({ checkbox1: updatedValue });
        }
        break;
      case "checkbox2":
        if (checkbox2 !== updatedValue) {
          setCheckbox2(updatedValue);
          updateSubmissionData({ checkbox2: updatedValue });
        }
        break;
      case "checkbox3":
        if (checkbox3 !== updatedValue) {
          setCheckbox3(updatedValue);
          updateSubmissionData({ checkbox3: updatedValue });
        }
        break;
      case "checkbox4":
        if (checkbox4 !== updatedValue) {
          setCheckbox4(updatedValue);
          updateSubmissionData({ checkbox4: updatedValue });
        }
        break;
      default:
        break;
    }
  };

  const handleRadioChange = (e) => {
    if (radioValue !== e.target.value) {
      setRadioValue(e.target.value);
      updateSubmissionData({ radioValue: e.target.value });
    }
  };

  const handleNumberChange = (e) => {
    if (numberInput !== e.target.value) {
      setNumberInput(e.target.value);
      updateSubmissionData({ numberInput: e.target.value });
    }
  };

  const handleTextChange = (e) => {
    if (textInput !== e.target.value) {
      setTextInput(e.target.value);
      updateSubmissionData({ textInput: e.target.value });
    }
  };

  return (
    <div className="mb-2" style={{ fontFamily: "Manrope-Regular" }}>
      <button
        className="btn btn-outline-primary d-flex align-items-center justify-content-between"
        style={buttonStyle}
        onClick={handleToggleForm}
      >
        <LuClipboard size={30} />
        <span>Submission</span>
        <IoIosArrowDown />
      </button>

      {showForm && (
        <div className="mt-2">
          <form className="text-start p-4 border rounded">
            <h6 className="fw-bold">Maximum no of attempts</h6>
            <DropdownButton
              title={selectedValue}
              onSelect={handleSelect}
              variant="outline-secondary"
              className="mb-3"
            >
              <Dropdown.Item eventKey="1">1</Dropdown.Item>
              <Dropdown.Item eventKey="2">2</Dropdown.Item>
              <Dropdown.Item eventKey="3">3</Dropdown.Item>
              <Dropdown.Item eventKey="4">4</Dropdown.Item>
              <Dropdown.Item eventKey="5">5</Dropdown.Item>
              <Dropdown.Item eventKey="6">6</Dropdown.Item>
              <Dropdown.Item eventKey="7">7</Dropdown.Item>
              <Dropdown.Item eventKey="8">8</Dropdown.Item>
              <Dropdown.Item eventKey="9">9</Dropdown.Item>
              <Dropdown.Item eventKey="10">10</Dropdown.Item>
              <Dropdown.Item eventKey="25">25</Dropdown.Item>
              <Dropdown.Item eventKey="50">50</Dropdown.Item>
              <Dropdown.Item eventKey="100">100</Dropdown.Item>
              <Dropdown.Item eventKey="unlimited">unlimited</Dropdown.Item>
            </DropdownButton>

            <Form.Check
              type="checkbox"
              label="Allow group submission"
              checked={checkbox1}
              onChange={() => handleCheckboxChange("checkbox1", checkbox1)}
              className="mb-2"
            />
            <p style={{ fontSize: "12px", color: "#5F6368" }}>
              Allow users to make submissions in groups. You can configure the
              groups after enabling
            </p>

            <Form.Check
              type="checkbox"
              label="Time Limit"
              checked={checkbox2}
              onChange={() => handleCheckboxChange("checkbox2", checkbox2)}
              className="mb-2"
            />
            <p style={{ fontSize: "12px", color: "#5F6368" }}>
              Once started, a user taking this quiz must complete it within the
              given time
            </p>

            <div className="row mb-3">
              <div className="col-md-6">
                <Form.Control
                  type="number"
                  placeholder="60"
                  value={numberInput}
                  onChange={handleNumberChange}
                />
              </div>
              <div className="col-md-6">
                <Form.Control
                  type="text"
                  placeholder="Minutes"
                  value={textInput}
                  onChange={handleTextChange}
                  readOnly
                />
              </div>
            </div>

            <h6 className="fw-bold">View Scores</h6>
            <Form.Check
              type="checkbox"
              label="View scores immediately"
              checked={checkbox3}
              onChange={() => handleCheckboxChange("checkbox3", checkbox3)}
              className="mb-2"
            />
            <Form.Check
              type="checkbox"
              label="View question scores immediately"
              checked={checkbox4}
              onChange={() => handleCheckboxChange("checkbox4", checkbox4)}
              className="mb-3"
            />
            <h6 className="fw-bold">View Correct Answers</h6>
            <p style={{ fontSize: "12px", color: "#5F6368" }}>
              When should users be able to view correct answers to the questions?
            </p>

            <Form.Check
              type="radio"
              label="After attempting each question"
              name="modeOptions"
              value="A"
              checked={radioValue === "A"}
              onChange={handleRadioChange}
              className="mb-2"
            />
            <Form.Check
              type="radio"
              label="After max. attempts"
              name="modeOptions"
              value="B"
              checked={radioValue === "B"}
              onChange={handleRadioChange}
              className="mb-2"
            />
            <Form.Check
              type="radio"
              label="Once scores are published"
              name="modeOptions"
              value="C"
              checked={radioValue === "C"}
              onChange={handleRadioChange}
              className="mb-2"
            />
            <Form.Check
              type="radio"
              label="Never"
              name="modeOptions"
              value="D"
              checked={radioValue === "D"}
              onChange={handleRadioChange}
              className="mb-2"
            />
          </form>
        </div>
      )}
    </div>
  );
}

export default Submission;
